import { Account } from 'shared/types/account';
import { gtmTrackEvent, gtmTrackEventError } from './gtmTrackEvent';
import { AccountMapper } from './mapper/AccountMapper';

export const gtmApplyPromoCode = (code: string) => {
  const eventKey = 'apply_promo_code';
  try {
    const eventObject = {
      interaction: {
        promo_code: code,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmImageScroll = ({
  click_action,
  item_id,
  media_name,
}: {
  click_action: 'view images' | 'watch video';
  item_id: string;
  media_name: string;
}) => {
  const eventKey = 'image_scroll';

  try {
    const eventObject = {
      interaction: {
        click_action,
        item_id,
        media_name,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmAccordionInteraction = ({
  click_action,
  interaction_location,
  interaction_text,
}: {
  click_action: 'Expand' | 'Collapse';
  interaction_text: string;
  interaction_location: string;
}) => {
  const eventKey = 'accordion_interaction';

  try {
    const eventObject = {
      interaction: {
        click_action,
        interaction_location,
        interaction_text,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmMenuNavigation = ({ click_location, click_name }: { click_name: string; click_location: string }) => {
  const eventKey = 'menu_navigation';

  try {
    const eventOjbect = {
      interaction: {
        click_location,
        click_name,
      },
    };

    gtmTrackEvent(eventKey, eventOjbect);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmBreadcrumbClick = (text: string) => {
  const eventKey = 'breadcrumb_click';

  try {
    const eventObject = {
      interaction: {
        click_name: text,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmFormStartInteraction = (formName: string) => {
  const eventKey = 'form_start';

  try {
    const eventObject = {
      form_name: formName,
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmFormSubmit = ({
  catalogueFormat,
  formName,
  hashedEmail,
  newsletterOptIn,
  referralSource,
  region,
  country,
}: {
  formName: string;
  hashedEmail?: string;
  region?: string;
  referralSource?: string;
  country?: string;
  catalogueFormat?: string;
  newsletterOptIn?: boolean;
}) => {
  const eventKey = 'form_submit';
  try {
    const eventObject = {
      interaction: {
        form_name: formName,
        hashed_email: hashedEmail,
        region,
        referral_source: referralSource,
        country,
        catalogue_format: catalogueFormat,
        newsletter_opt_in: newsletterOptIn,
      },
    };

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmFormError = ({
  errorField,
  errorMessage,
  formName,
}: {
  formName: string;
  errorField: string;
  errorMessage: string;
}) => {
  const eventKey = 'form_error';
  try {
    const eventObject = {
      interaction: {
        form_name: formName,
        error_field: errorField,
        error_message: errorMessage,
      },
    };
    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};
export const gtmClickCta = ({ location, name }: { name: string; location: string }) => {
  const eventKey = 'click_cta';
  try {
    const eventObject = {
      interaction: {
        click_name: name,
        click_location: location,
      },
    };
    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};

export const gtmDownloadSpecSheet = ({
  product_name,
  product_sku,
  product_url,
  account,
}: {
  product_name: string;
  product_sku: string;
  product_url: string;
  account?: Account;
}) => {
  const eventKey = 'download_spec_sheet';

  try {
    const eventObject = {
      interaction: {
        product_name,
        product_sku,
        product_url,
      },
    };

    if (account) {
      const userObject = AccountMapper.fromAccountToGTMUser(account);
      Object.assign(eventObject, { user: userObject });
    }

    gtmTrackEvent(eventKey, eventObject);
  } catch (error: any) {
    gtmTrackEventError(error, eventKey);
  }
};
